import { getLoginToken, getRefreshSession, getRefreshToken } from "@/api/login";
import { jwtDecode, JwtPayload } from "jwt-decode";
import useGlobalEventBus from "../hooks/useGlobalEventBus";

const EventBus = useGlobalEventBus();

class AuthRefreshService {
  private static instance: AuthRefreshService;
  private bufferTime: number; // 提前刷新时间（秒）
  private isRefreshing = false; // 标志位，防止并发刷新

  private constructor(bufferTime = 300) {
    this.bufferTime = bufferTime; // 默认提前 5 分钟刷新
  }

  // 获取单例实例
  public static getInstance(bufferTime = 300): AuthRefreshService {
    if (!AuthRefreshService.instance) {
      AuthRefreshService.instance = new AuthRefreshService(bufferTime);
    }
    return AuthRefreshService.instance;
  }

  // 刷新 Token
  public async refreshToken(): Promise<boolean> {
    if (this.isRefreshing) {
      // eslint-disable-next-line no-console
      console.log("刷新操作正在进行中，跳过本次刷新");
      return false; // 如果正在刷新，直接返回
    }

    this.isRefreshing = true; // 设置标志位，表示刷新操作正在进行
     // eslint-disable-next-line no-console
    console.log("尝试刷新 token");
    try {
      const result: any = await getRefreshToken();
       // eslint-disable-next-line no-console
      console.log(result, "刷新结果");

      if (result.data.success) {
        localStorage.setItem("token", result.data.data);
        localStorage.setItem("iam-token", result.data.data);

        try {
          await getRefreshSession();
        } catch (error) {
           // eslint-disable-next-line no-console
          console.error(error, "刷新会话失败");
        }

        return true;
      }

      return false;
    } catch (err) {
       // eslint-disable-next-line no-console
      console.log("刷新 token 失败");
      return false;
    } finally {
      this.isRefreshing = false; // 重置标志位
    }
  }

  // 检查并刷新 Token
  public async checkAndRefreshToken(): Promise<void> {
    try {
      const token = localStorage.getItem("iam-token");
      if (!token) {
        throw new Error("No token found");
      }

      const decoded: any = jwtDecode<JwtPayload>(token);
      const currentTime = Math.floor(Date.now() / 1000);
      const timeUntilExpiry = decoded.exp - currentTime;
      // eslint-disable-next-line no-console
      console.log("检查 token 剩余时间：", timeUntilExpiry, "秒");
       // eslint-disable-next-line no-console
      console.log("提前：", this.bufferTime, "秒刷新");

      // 如果 token 剩余时间小于 bufferTime 秒，刷新 token
      if (timeUntilExpiry < this.bufferTime) {
         // eslint-disable-next-line no-console
        console.log("token 剩余时间小于", this.bufferTime, "执行刷新");
        await this.refreshToken();
      } else {
         // eslint-disable-next-line no-console
        console.log("token 剩余时间大于", this.bufferTime, "秒无需刷新");
      }
    } catch (error) {
       // eslint-disable-next-line no-console
      console.error("检查 token 失败：", error);
    }
  }
}

export default AuthRefreshService;